import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { TypeOfSelectors } from "app/pages/sales-intelligence/common-components/MultiSelector/types";
import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import {
    selectIsTableRowExpanded,
    LeadsExportOptionsDropdownContainer,
} from "app/pages/sales-intelligence/modules/leads-search";

import DynamicsExportPanelContainer from "../ExportPanel/DynamicsExportPanelContainer";
import ExcelExportPanelContainer from "../ExportPanel/ExcelExportPanelContainer";
import HubSpotExportPanelContainer from "../ExportPanel/HubSpotExportPanelContainer";
import SalesforceExportPanelContainer from "../ExportPanel/SalesforceExportPanelContainer";

type TableExportOptionsProps = TableActionProps & {
    isCrmExportDisabled?: boolean;
};

const TableExportOptionsContainer = (props: TableExportOptionsProps) => {
    const isTableRowExpanded = useSelector(selectIsTableRowExpanded);

    const handleSelect = (variant: TypeOfSelectors): void => {
        switch (variant) {
            case TypeOfSelectors.EXCEL:
                return props.onActivate(() => ExcelExportPanelContainer);
            case TypeOfSelectors.EXPORT_SALES_FORCE:
                return props.onActivate(() => SalesforceExportPanelContainer);
            case TypeOfSelectors.EXPORT_HUBSPOT:
                return props.onActivate(() => HubSpotExportPanelContainer);
            case TypeOfSelectors.EXPORT_DYNAMICS:
                return props.onActivate(() => DynamicsExportPanelContainer);
            default:
                return undefined;
        }
    };

    return (
        <LeadsExportOptionsDropdownContainer
            isDisabled={props.isDisabled || isTableRowExpanded}
            isExportDisabled={props.isCrmExportDisabled}
            tooltipProps={
                isTableRowExpanded
                    ? { tooltipContent: translate("si.websites-export.disabled.inner-table.text") }
                    : undefined
            }
            onOptionSelect={handleSelect}
        />
    );
};

export default TableExportOptionsContainer;
